import { render, staticRenderFns } from "./DashboardDelegates.vue?vue&type=template&id=58a30ea0&scoped=true&"
import script from "./DashboardDelegates.vue?vue&type=script&lang=js&"
export * from "./DashboardDelegates.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDelegates.vue?vue&type=style&index=0&id=58a30ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a30ea0",
  null
  
)

export default component.exports